module.exports = __webpack_public_path__ + "static/media/ava.10ade501.png";